import { Link } from "react-router-dom";
import { Check, MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import {
  Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,
  BreadcrumbPage, BreadcrumbSeparator,
} from "../components/ui/breadcrumb";
import { Button } from "../components/ui/button";
import { INSTITUCIONAL, COMPANY } from "../data/store";

const Card = ({ title, children }) => (
  <div className="bg-white border border-slate-200 rounded-lg p-6">
    <h2 className="text-lg font-semibold text-slate-900 mb-2">{title}</h2>
    <div className="text-slate-600 leading-relaxed">{children}</div>
  </div>
);

const Sobre = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <Breadcrumb className="mb-4">
      <BreadcrumbList>
        <BreadcrumbItem><BreadcrumbLink asChild><Link to="/">Início</Link></BreadcrumbLink></BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem><BreadcrumbPage>Sobre a Sulbel</BreadcrumbPage></BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>

    <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 mb-2">Sobre a Sulbel</h1>
    <p className="text-slate-500 mb-8 max-w-2xl">{COMPANY.legal} · CNPJ {COMPANY.cnpj}</p>

    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 space-y-6">
        <Card title="Nossa história"><p>{INSTITUCIONAL.historia}</p></Card>
        <div className="grid sm:grid-cols-2 gap-6">
          <Card title="Missão"><p>{INSTITUCIONAL.missao}</p></Card>
          <Card title="Visão"><p>{INSTITUCIONAL.visao}</p></Card>
        </div>
        <Card title="Valores">
          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2 mt-1">
            {INSTITUCIONAL.valores.map((v) => (
              <li key={v} className="flex items-center gap-2"><Check className="h-4 w-4 text-brand shrink-0" /> {v}</li>
            ))}
          </ul>
        </Card>
      </div>

      <aside className="lg:col-span-1">
        <div className="bg-white border border-slate-200 rounded-lg p-6 sticky top-24">
          <h2 className="text-lg font-semibold text-slate-900 mb-4">Fale conosco</h2>
          <ul className="space-y-3 text-sm text-slate-600">
            <li className="flex items-start gap-2.5"><MapPin className="h-4 w-4 text-brand mt-0.5 shrink-0" /> {COMPANY.address}</li>
            <li className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-brand shrink-0" /> {COMPANY.phone}</li>
            <li className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-brand shrink-0" /> {COMPANY.email}</li>
            <li className="flex items-start gap-2.5"><Clock className="h-4 w-4 text-brand mt-0.5 shrink-0" /> {COMPANY.hours}</li>
          </ul>
          <Button asChild className="mt-5 w-full h-11 bg-brand hover:bg-brand-hover text-white font-semibold">
            <a href={`https://wa.me/${COMPANY.whatsapp}`} target="_blank" rel="noreferrer" data-testid="sobre-whatsapp">
              <MessageCircle className="h-4 w-4 mr-2" /> Falar no WhatsApp
            </a>
          </Button>
        </div>
      </aside>
    </div>
  </div>
);

export default Sobre;
